import React, { useEffect, useState, useRef } from 'react';
import { Dropdown } from 'semantic-ui-react';
import * as _ from 'lodash';
import PropTypes from 'prop-types';

function getDropDownOptions(options) {
  if (typeof options === 'object') {
    return Array.isArray(options) ? options : options.items;
  }
  return [];
}

function getDropdownValue({ isDropdownLoading, multiple, value }) {
  if (isDropdownLoading) return multiple ? [] : '';
  return value;
}

function CustomDropdown({ options, value, placeholder, additionalInfo, additionalInfoLabel, disabled, ...props }) {
  const { multiple, onSearchChange } = props;
  const dropDownOptions = getDropDownOptions(options);
  const isDropdownLoading = _.isNil(options && options.isLoading) ? false : options.isLoading;
  const onSearching = _.isNil(options && options.isLoading) ? false : options.isSearching;
  const [noResultMessage, setNoResultMessage] = useState(
    onSearchChange ? 'Type atleast three letter to search' : 'No Results Found'
  );
  const textInput = useRef(null);

  useEffect(() => {
    const inputLength = _.get(textInput, 'current.state.searchQuery');

    if (inputLength && inputLength.length < 3) {
      setNoResultMessage('Type atleast three letter to search');
    } else if (inputLength && inputLength.length >= 3 && isDropdownLoading !== true && dropDownOptions.length === 0) {
      setNoResultMessage('No Results Found');
    }
  }, [options]);
  return (
    <>
      <Dropdown
        {...props}
        value={getDropdownValue({ isDropdownLoading, multiple, value })}
        placeholder={isDropdownLoading ? 'Loading...' : placeholder}
        disabled={!onSearching && isDropdownLoading ? true : disabled}
        options={isDropdownLoading ? [] : dropDownOptions}
        loading={onSearching}
        noResultsMessage={noResultMessage}
        ref={textInput}
      />
      {additionalInfo && (
        <div>
          {additionalInfoLabel && <>{additionalInfoLabel}:&nbsp;</>}
          <pre style={{ whiteSpace: 'break-spaces' }}>{additionalInfo}</pre>
        </div>
      )}
    </>
  );
}

const dropdownOptionsPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    key: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })
);

CustomDropdown.propTypes = {
  options: PropTypes.oneOfType([
    dropdownOptionsPropTypes,
    PropTypes.shape({
      items: dropdownOptionsPropTypes,
      isLoading: PropTypes.bool.isRequired,
    }),
  ]).isRequired,
  value: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
  placeholder: PropTypes.string.isRequired,
  disabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf([null])]),
  multiple: PropTypes.bool,
  onSearchChange: PropTypes.func,
  additionalInfo: PropTypes.string,
  additionalInfoLabel: PropTypes.string,
  clearable: PropTypes.bool,
  fluid: PropTypes.bool,
  search: PropTypes.bool,
  selection: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  name: PropTypes.string,
  style: PropTypes.object,
  selectOnBlur: PropTypes.bool,
};

CustomDropdown.defaultProps = {
  disabled: false,
  multiple: false,
};

export default CustomDropdown;
